import React from 'react'

type ChevronsIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
  direction?: 'left' | 'right'
}

export const ChevronsIcon = ({
  width = 20,
  height = 20,
  className,
  color = '#0A2B1F',
  direction = 'right',
}: ChevronsIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={direction === 'left' ? { transform: 'scaleX(-1)' } : undefined}
  >
    <path
      d="M10.8333 14.1693L15 10.0026L10.8333 5.83594M5 14.1693L9.16667 10.0026L5 5.83594"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
